import { useEffect, useState } from "react";
import { useDrawerContext } from "../../modules/drawer";

const useCard = (
  containerRef: any,
  cardGap: number,
  cardMaxNumberPerRow: number,
  cardMinWidth: number,
  cardMaxWidth: number | undefined,
  paddingX: number
) => {
  const useGetContainerWidth = (containerRef: any) => {
    const [width, setWidth] = useState(0);
    const { isOpen } = useDrawerContext();
    useEffect(() => {
      if (!containerRef?.current) return;
      const getWidth = () => containerRef?.current && containerRef?.current.offsetWidth;

      const handleResize = () => {
        setWidth(getWidth());
      };

      if (containerRef?.current) {
        setWidth(getWidth());
      }

      window.addEventListener("resize", handleResize);

      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, [containerRef]);

    useEffect(() => {
      if (!containerRef?.current) return;
      const getWidth = () => containerRef?.current && containerRef?.current.offsetWidth;
      if (containerRef?.current)
        setTimeout(() => {
          setWidth(getWidth());
        }, 400);
    }, [isOpen, containerRef]);

    return width;
  };

  const calculateCardWidth = (
    width: number,
    maxCards: number,
    minWidth: number,
    maxWidth: number | undefined,
    gap: number,
    paddingX: number
  ): string => {
    const usable = width - paddingX;
    if (usable <= minWidth) {
      return `${minWidth}px`;
    }

    const maxByMin = Math.floor((usable + gap) / (minWidth + gap));
    const minByMax = maxWidth !== undefined ? Math.ceil((usable + gap) / (maxWidth + gap)) : 1;

    const cards = Math.max(1, Math.min(maxCards, maxByMin, Math.max(1, minByMax)));

    const per = (width - (cards - 1) * gap - paddingX) / cards;
    return `${per}px`;
  };

  const containerWidth = useGetContainerWidth(containerRef);
  const cardWidth = calculateCardWidth(
    containerWidth,
    cardMaxNumberPerRow,
    cardMinWidth,
    cardMaxWidth,
    cardGap,
    paddingX
  );

  return {
    containerWidth,
    cardWidth,
  };
};

export default useCard;
